import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { TabWithRoute } from './tab-with-route.interface';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'tab-with-routing',
	styleUrls: ['./tab-with-routing.component.scss', '../tabs.component.scss'],
	templateUrl: './tab-with-routing.component.html'
})
export class TabWithRoutingComponent implements OnInit {
	@Input() public tabsWithRoutes: Array<TabWithRoute>;
	@Input() public useUnderlineSkin: boolean;

	public queryParams;

	constructor(private route: ActivatedRoute) { }

	public ngOnInit(): void {
		this.route.queryParams.subscribe(params => {
			this.queryParams = params;
		});
	}
}
